import * as Yup from 'yup';

import { FIELD_IS_REQUIRED } from 'src/common/validation/errors';
import type { ICustomerLeadProductInitialRequestTabFormValues } from 'src/components/customers/CustomerLeadTypes';
import type { CustomerLeadPurchaseReason } from 'src/types/customers/CustomerLeadPurchaseReason';
import type { CustomerLeadUrgency } from 'src/types/customers/CustomerLeadUrgency';
import type { ICustomerLeadProduct } from 'src/types/customers/ICustomerLeadProduct';

export const customerLeadInitialRequestTabValidationSchema =
  Yup.object<ICustomerLeadProductInitialRequestTabFormValues>().shape({
    urgency: Yup.mixed<CustomerLeadUrgency>().required(FIELD_IS_REQUIRED).default(null),
    maxQtySingleDelivery: Yup.number().nullable().default(null),
    purchaseReasons: Yup.array().of(Yup.mixed<CustomerLeadPurchaseReason>().required()).nullable().default([]),
  });

export function toCustomerLeadInitialRequestTabInitialValues(
  customerLeadProduct: ICustomerLeadProduct
): ICustomerLeadProductInitialRequestTabFormValues {
  return {
    urgency: customerLeadProduct.urgency,
    maxQtySingleDelivery: customerLeadProduct.maxQtySingleDelivery,
    purchaseReasons: customerLeadProduct.purchaseReasons,
  };
}
